import {Component, forwardRef} from '@angular/core';
import {NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NumberInputComponent} from '../number-input.component';

@Component({
    selector: 'kiwi-percentage-input',
    templateUrl: './input-with-unit.component.html',
    styleUrls: ['./input-with-unit.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => PercentageInputComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PercentageInputComponent),
            multi: true
        }
    ],
    standalone: false
})

export class PercentageInputComponent extends NumberInputComponent {
    constructor() {
        super();
        this.unit = '%';
        this.step = 0.01;
    }

    writeValue(obj: number) {
        if (obj != null) {
            this.data = obj * 100;
        } else {
            this.data = obj;
        }
    }


    onChange(value: number) {
        this.data = value;
        this.onNgChange(value / 100);
    }
}
